import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

import LogoImage from '@/assets/svg/purge/logo.svg'

function MainBanner() {
  const { t } = useTranslation('forBrands')

  return (
    <div className="flex flex-col-reverse items-center w-full space-y-12 md:flex-row box">
      <div className="flex-1">
        <Image
          src="/images/for-brands/MainImage.png"
          width={500}
          height={390}
        />
      </div>
      <div className="flex-1 sm:px-4 lg:px-16">
        <h1 className="text-2xl font-medium sm:text-3xl lg:text-6xl">
          {t('title')}{' '}
          <span className="inline-block w-16 text-[#837ddd] sm:w-20 lg:w-40">
            <LogoImage />
          </span>
          ?
        </h1>
        <div className="flex flex-col my-10 space-y-6">
          <p className="sm:text-xl lg:text-2xl">{t('description.0')}</p>
          <p className=" sm:text-xl lg:text-2xl">{t('description.1')}</p>
          <p className=" sm:text-xl lg:text-2xl">
            <span className="font-bold text-[#837ddd]">fansi</span>{' '}
            {t('description.2')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default MainBanner
